import { TenantCustomDomainAPI } from "../api/custom-domain-api/CustomDomainApi";
import Cookies from "js-cookie";

const getHeaders = async (hostname, includeContentType = true) => {
  let subdomain = hostname?.split(".")[0];
  const customTenant = Cookies.get("custom_tenant");

  const baseHeaders = (tenantId) => {
    const headers = {
      "X-Tenant-Id": tenantId,
    };

    if (includeContentType) {
      headers["Content-Type"] = "application/json";
    }

    return headers;
  };

  if (!hostname?.includes("localhost") && !customTenant) {
    const res = await TenantCustomDomainAPI(hostname);
    console.log("first if", res?.response);

    Cookies.set("custom_tenant", res?.response?.tenantCode, {
      path: "/",
      domain: res?.response?.customDomain,
      secure: true,
      sameSite: "Strict",
    });

    return baseHeaders(res?.response?.tenantCode);
  }

  if (customTenant) {
    console.log("customTenant if", customTenant);
    return baseHeaders(customTenant);
  } else if (
    subdomain === "www" ||
    subdomain === "localhost" ||
    hostname.includes("www.padami.in") ||
    hostname.includes("www.qaebe.online")
  ) {
    console.log("else if", subdomain);
    return baseHeaders(process.env.NEXT_PUBLIC_DEFAULT_TENANT_ID || "superadmin");
  } else {
    console.log("else ", subdomain);
    return baseHeaders(subdomain);
  }
};



export const getTenantName = async (hostname) => {
  let subdomain = hostname?.split(".")[0];
  const customTenant = Cookies.get("custom_tenant");


  if (!hostname?.includes("localhost") && !customTenant) {
    const res = await TenantCustomDomainAPI(hostname);
    console.log("first if", res?.response);

    Cookies.set("custom_tenant", res?.response?.tenantCode, {
      path: "/",
      domain: res?.response?.customDomain,
      secure: true,
      sameSite: "Strict",
    });

    return res?.response?.tenantCode;
  }

  if (customTenant) {
    console.log("customTenant if", customTenant);
    return customTenant;
  } else if (
    subdomain === "www" ||
    subdomain === "localhost" ||
    hostname.includes("www.padami.in") ||
    hostname.includes("www.qaebe.online")
  ) {
    console.log("else if", subdomain);
    return "superadmin";
  } else {
    console.log("else ", subdomain);
    return subdomain;
  }
};


export default getHeaders;
